<template>
  <v-container fluid class="px-0">
    <v-row class="align-end" dense>
      <v-col>
        <v-file-input
          v-if="!localFile.filename"
          accept=".xlsx"
          show-size
          hide-details
          @change="selectFile"
          :disabled="logView || !editMode"
          :loading="updating"
          :label="fileLabel"
        />
        <div v-else class="d-flex text-wrap align-end justify-lg-space-between">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                @click="downloadFile"
                v-bind="attrs"
                v-on="on"
                class="link blue--text font-italic"
              >
                <v-icon class="blue--text" left>mdi-file-excel-outline</v-icon
                >{{ localFile.filename }}
              </span>
            </template>
            <span
              >Скачать файл<v-icon color="white" right
                >mdi-download</v-icon
              ></span
            >
          </v-tooltip>
          <v-file-input
            v-if="!logView && editMode"
            class="justify-end"
            accept=".xlsx"
            hide-input
            show-size
            hide-details
            @change="selectFile"
            :loading="updating"
            :title="replaceFileTitle"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as Exceljs from 'exceljs'
import { copyObject } from '@/lib/objects'
import {
  parseGoPricingGoReleaseWorkbook,
  parseGoPricingMainWorkbook,
  parseGoPricingProcurementWorkbook,
  parseGoPricingPricingWorkbook,
} from '@/components/expGoPricing/parseWorkbook'

export default {
  name: 'UpdateGoPricing',
  props: {
    variant: {
      type: String,
      default: 'main',
      validator: v => ['main', 'go', 'procurement', 'pricing'].includes(v),
    },
    logView: {
      type: Boolean,
      default: false,
    },
    localFile: {
      type: Object,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    file: null,
    updating: false,
  }),
  computed: {
    ...mapGetters(['storedPlpId']),
    fileLabel() {
      if (this.variant === 'go') {
        return 'Excel с листом «Выпуск в ГО»'
      }
      if (this.variant === 'procurement') {
        return 'Excel с листом «Закупки»'
      }
      if (this.variant === 'pricing') {
        return 'Excel с листом «Ценовая характеристика»'
      }
      return 'Excel: листы «Выпуск в ГО и план (ФВ-n)»'
    },
    replaceFileTitle() {
      return 'Заменить файл Excel'
    },
  },
  methods: {
    ...mapActions(['CREATE_PLP_FILE', 'GET_PLP_FILE']),
    doChange(data, force = false) {
      this.$emit('change', data, force)
    },
    emitParseError(message) {
      this.$emit('parse-error', { variant: this.variant, message })
    },
    async downloadFile() {
      await this.GET_PLP_FILE(this.localFile)
    },
    async compileManual(changeFile = false) {
      let localFile = null
      const workbook = new Exceljs.Workbook()
      await workbook.xlsx.load(this.file)

      let payload
      if (this.variant === 'main') {
        const { sheets } = parseGoPricingMainWorkbook(workbook)
        payload = { kind: 'main', sheets: copyObject(sheets), localFile: null }
      } else if (this.variant === 'go') {
        const { name, rows } = parseGoPricingGoReleaseWorkbook(workbook)
        payload = { kind: 'go', name, rows, localFile: null }
      } else if (this.variant === 'procurement') {
        const { name, rows } = parseGoPricingProcurementWorkbook(workbook)
        payload = { kind: 'procurement', name, rows, localFile: null }
      } else {
        const { name, rows } = parseGoPricingPricingWorkbook(workbook)
        payload = { kind: 'pricing', name, rows, localFile: null }
      }

      if (changeFile) {
        localFile = await this.CREATE_PLP_FILE({
          plp_id: this.storedPlpId,
          filename: this.file.name,
          file: this.file,
        })
        payload.localFile = localFile
      }

      this.doChange(payload, true)
    },
    async selectFile(file) {
      this.file = file
      if (!this.file) return
      this.updating = true
      try {
        await this.compileManual(true)
      } catch (e) {
        this.emitParseError(e.message || String(e))
      } finally {
        this.updating = false
      }
    },
  },
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
</style>
